import api from '@/helpers/api'
import axios from '@/helpers/axios'

export default {
    namespaced: true,

    state: {
        completed:[],
    },

    getters: {
        completed: state => state.completed,
    },

    mutations: {
        ADD_PAGE(state, page) {
            if(!state.completed.includes(page.section)){
                state.completed.push(page.section);
                axios.post(api.API_ENDPOINTS.m3company + this.getters['m3Sketch/m3Company'].id + '/project/progress', { section: page.section });
            }
        },

        REMOVE_PAGE(state, page) {
            if(state.completed.includes(page.section)){
                state.completed.splice(state.completed.indexOf(page.section), 1);
                axios.post(api.API_ENDPOINTS.m3company + this.getters['m3Sketch/m3Company'].id + '/project/progress', { section: page.section, _method: 'DELETE' });
            }
        },

        INITIALIZE_COMPLETED_PAGES(state) {
            axios.get(api.API_ENDPOINTS.m3company + this.getters['m3Sketch/m3Company'].id)
                .then( response => {
                    if(response && response.data && response.data.m3_project && response.data.m3_project.progress && response.data.m3_project.progress.length)
                        state.completed = response.data.m3_project.progress;
                    else
                        state.completed = [];
                })
        },
    },

    actions: {

        addPage({commit}, page) {
            commit('ADD_PAGE', page)
        },

        removePage({commit}, page) {
            commit('REMOVE_PAGE', page);
        },

        initializeCompletedPages({commit}) {
            commit('INITIALIZE_COMPLETED_PAGES');
        }
    },
}
